module.exports = fox._r("images/christmass/gift-164.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/christmass/gift-164.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/christmass/gift-164.png
// module id = 365
// module chunks = 4